<template>
  <nav class="nav" :class="{ 'nav--org': orgNav, 'nav--parking': parkingNav }" v-if="routeLayout.isNav || isLoad"><!-- 261012 nav--org = 기관 템플릿 회원 3탭(밝은 바) · 261019 nav--parking = 주차판 홈 회원 3탭(간판ON 검은 바 그대로, 유저 '톤은 맞춰야지') -->
    <!-- 260716 대표: 좌2(홈/탐색) + 중앙 공유 FAB + 우2(마이/정품등록). '나의 간판' 탭 제거로 4탭 균등·FAB 정중앙
         260918 대표 회의: 탐색→'주변 간판'(아이콘 유지), 정품등록 탭 폐지 → '통계'(/more/stats). 정품등록 라우트는 딥링크 착지로 존치. -->
    <div class="nav-side">
      <button class="nav-icon" :class="currentURL === NAV_URL().HOME ? 'on' : ''" @click="fnMove(NAV_URL().HOME)">
        <svg class="nav-svg" viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 17H12.009" />
          <path d="M20 8.5V13.5C20 17.2712 20 19.1569 18.8284 20.3284C17.6569 21.5 15.7712 21.5 12 21.5C8.22876 21.5 6.34315 21.5 5.17157 20.3284C4 19.1569 4 17.2712 4 13.5V8.5" />
          <path d="M22 10.5L17.6569 6.33548C14.9902 3.77849 13.6569 2.5 12 2.5C10.3431 2.5 9.00981 3.77849 6.34315 6.33548L2 10.5" />
        </svg>
        <span class="ttl">홈</span>
      </button>
      <button v-if="!slimNav" class="nav-icon" :class="currentURL === NAV_URL().SEARCH ? 'on' : ''" @click="$router.push('/business')">
        <svg class="nav-svg" viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M19 11.5C19 15.5 14 20 14 20S9 15.5 9 11.5A5 5 0 0 1 19 11.5Z" />
          <circle cx="14" cy="11.5" r="1.5" />
          <path d="M3 9A8 8 0 0 1 8 4" />
          <path d="M5 11A5.5 5.5 0 0 1 8.5 7.5" />
        </svg>
        <span class="ttl">주변 간판</span>
      </button>
    </div>

    <!-- 261012 기관 템플릿 회원은 공유 FAB 없음(간판ON 공유 기능) · 261019 주차판 홈 회원도 -->
    <button
      v-if="!slimNav"
      class="nav-icon more-btn"
      :class="isFloating ? 'on' : ''"
      @click="store.commit('layout/setIsFloating', !isFloating)"
    >
      <span class="round">
        <!-- 260609: 공유 아이콘 — 시안 제공 에셋(share-03) 그대로 사용 -->
        <img v-if="!isFloating" :src="fabShare" class="fab-ico fab-ico--img" alt="공유" />
        <!-- 플로팅 열림 시 닫기(X) — 260612 공유 리뉴얼: 검정(Figma cancel-01) -->
        <svg v-else class="fab-ico" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2.4" stroke-linecap="round" aria-hidden="true">
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      </span>
    </button>

    <div class="nav-side">
      <!-- 261012 기관 템플릿 회원 — 간판ON 기능(주변 간판·통계·공유) 대신 알림(홈·알림·마이 3탭) -->
      <button v-if="slimNav" class="nav-icon" :class="currentURL.startsWith('/more/notification') ? 'on' : ''" @click="fnMove('/more/notification')">
        <svg class="nav-svg" viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-2 7-2 9h16c0-2-2-2-2-9Z" />
          <path d="M10 21h4" />
        </svg>
        <span class="ttl">알림</span>
      </button>
      <!-- 260918 대표 회의: 통계 탭(통합 통계 /more/stats, 가맹점 게이트는 페이지 안). 인라인 SVG 막대차트 —
           비활성 회색/활성 블루를 stroke 로 칠해야 해서 PNG 대신 SVG(정품등록 탭과 같은 이유). 활성은 /more/stats 하위 전부. -->
      <button v-if="!slimNav" class="nav-icon" :class="currentURL.startsWith('/more/stats') ? 'on' : ''" @click="fnMove('/more/stats')">
        <svg class="nav-svg" viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M3 20H21" />
          <path d="M6.5 17.5V13" />
          <path d="M12 17.5V8" />
          <path d="M17.5 17.5V4" />
        </svg>
        <span class="ttl">통계</span>
      </button>
      <button class="nav-icon " :class="moreClass" @click="fnMove(NAV_URL().MORE)">
        <svg class="nav-svg" viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="8.5" />
          <circle cx="12" cy="9" r="2.5" />
          <path d="M7.5 17C8.3 14.8 9.9 13.6 12 13.6C14.1 13.6 15.7 14.8 16.5 17" />
        </svg>
        <span class="ttl">마이</span>
      </button>
    </div>
  </nav>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { NAV_URL } from '@/common/constants/ConstCode';
import router from '@/router';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
import { modalList, show, showTextModal } from '@/common/utils/ModalState';
// 260609 리뉴얼: 하단 네비 아이콘 (흰 라인 → CSS filter로 회색/초록 렌더)
// 260609: FAB 공유 아이콘 — 시안 제공 에셋
import fabShare from '@/assets/static/images/renewal/fab-share.png';
import { isCachedParking } from '@/common/utils/parkingHome.mjs'; // 261019 주차판 홈 마지막 판정 기억

const { getters } = useStore();
const { push, replace } = useRouter();
const route = useRoute();

const props = defineProps({
  isLoad: {
    type: Boolean,
    default: false
  }
});

const currentRoute = computed(() => {
  if (route.path.includes('business'))  {
    store.commit('layout/setIsBackFromSearch', false);
  }
  return null;
});

const user = computed(() => store.getters['user/getUserData']);
const currentURL = computed(() => router.currentRoute.value.path);
const isFloating = computed(() => store.getters['layout/getIsFloating']);
// 261012 학원·교회 회원 첫 화면(기관 템플릿) 회원 — 홈·알림·마이 3탭(ServiceLanding 이 판정 뒤 layout/setOrgNav)
// 261020 유저 "간판온 메인에서만 네비게이션 바가 원래 UI대로" — 회원이 '간판ON 둘러보기'로 간판ON 화면에 들어간 동안(ServiceLanding 이 layout/setMemberBrowse)은
//   회원 표식을 끄고 원래 탭바(홈·주변 간판·공유·통계·마이). 다른 화면으로 가도 그대로, 홈 탭으로 돌아와 회원 첫 화면이 뜨면 ServiceLanding 이 끈다.
const memberBrowse = computed(() => store.getters['layout/getMemberBrowse'] === true);
const orgNav = computed(() => !memberBrowse.value && store.getters['layout/getOrgNav'] === true);
// 261019 주차판 홈 회원(주차판만 있고 사장님 아님)도 같은 3탭 — ServiceLanding·/parking 이 판정 뒤 layout/setParkingNav.
//   홈을 거치지 않고 다른 화면부터 열려도 마지막 판정 기억(스위치 켜짐일 때만)으로 같은 탭을 그린다. 기관 템플릿이 먼저 이긴다.
const parkingNav = computed(() => !memberBrowse.value && !orgNav.value && (store.getters['layout/getParkingNav'] === true
    || isCachedParking(window.localStorage, user.value?.userNo, store.getters['common/getFeatureFlags'])));
const slimNav = computed(() => orgNav.value || parkingNav.value);
const isHamburger = computed(() => store.getters['layout/getIsHamburger']);

const openHamburger = () => {
  store.commit('layout/setIsHamburger', !isHamburger.value);
};
const routeLayout = computed(() => {
  return getters['layout/getRouteLayout'];
});

const moreClass = computed(() => {
  let innerClass = '';
  if (user.value.userNo && !user.value.isRead) innerClass += 'essen ';
  if (currentURL.value === NAV_URL().MORE) innerClass += 'on ';
  return innerClass;
});

const fnMove = async url => {
  // 같은 탭 재탭 → 그 화면 최상단으로 스크롤 (홈). router.push는 중복 이동이라 무시되므로 여기서 처리.
  if (router.currentRoute.value.path === url) {
    if (url === NAV_URL().HOME) {
      // 260826: 홈이 /main → /intro 로 바뀌면서 스크롤 주체도 바뀌었다.
      //   소개 랜딩은 .ls 가 스크롤하고 기존 메인은 .main .inner 가 스크롤한다.
      //   .main .inner 만 찾으면 랜딩에서 재탭이 아무 일도 안 한다.
      // 260923 대표 회의 "밑에서 홈 누르면 위로 올라가는 거": 260908 main-v2 교체로 랜딩 루트가 .ls → .gp(ServiceLanding 2행,
      //   overflow-y:auto)로 바뀌었는데 여기만 .ls 로 남아 재탭이 다시 무반응이었다. .main .inner 는 구 메인 폴백.
      const top = document.querySelector('.gp') || document.querySelector('.main .inner');
      top?.scrollTo({ top: 0, behavior: 'smooth' });
    }
    return;
  }
  if (isEmpty(user.value.userNo) && (url.includes('/welldying') || url.includes('/more'))) {
    showTextModal('로그인 후 이용가능합니다.', '확인', () => {
      router.push('/signin');
    });
    return;
  }
  await router.push(url);
};


const fnSearch = async url => {
  if (isEmpty(user.value.userNo) && (url.includes('/welldying') || url.includes('/more'))) {
    showTextModal('로그인 후 이용가능합니다.', '확인', () => {
      router.push('/signin');
    });
  }
  await router.push(url);
};

const fnShowWellPasswordInput = () => {
  if (route.path === '/welldying') return;
  // 260922 대표: 미설정도 모달(setup) — HamburgerMenu 와 동일.
  show(modalList.WELL_PASSWORD_MODAL, user.value.hasWellPassword ? { title: '웰다잉 비밀번호 입력' } : { title: '웰다잉 비밀번호 설정', mode: 'setup' });
  // fnMove(`/welldying?title=${user.value.name}님`);
};

// 260716 대표: '나의 간판' 탭 제거(4탭+FAB 정중앙) — fnMyBusiness/navSignboard 폐기. 나의 간판은 마이/홈 경유 진입.
</script>

<style scoped>
/* 260609 리뉴얼: 검은 푸터(시안) + 라인 아이콘(비활성 라이트그레이 / 활성 그린) */
.nav {
  background: #0d0d0d !important;
  box-shadow: 0 -0.1rem 0 rgba(255, 255, 255, 0.06) !important;
  /* 260811 유저(스샷 빨간 원 3곳) — 원형 6rem에서 아이콘이 아래 붙어 위가 빈 검은 띠.
     검은 스킨에선 바를 타이트하게. */
  height: 5rem !important;
}
/* FAB 뒤 흰 알약(pill) 제거 + 네비 상단에 반쯤 걸치게 위로 띄움(시안) */
.nav-icon.more-btn {
  background: transparent !important;
  border-top: 0 !important;
  transform: translateY(-1.2rem); /* 260811 — 띄움을 살짝 줄여 FAB 아래 검은 구멍 축소 */
}
/* 라벨 — 비활성 라이트그레이 / 활성 그린 */
.nav-icon .ttl {
  color: #9aa0a6 !important;
  font-size: 1.2rem !important;
  font-weight: 500 !important;
  letter-spacing: -0.02em;
  white-space: nowrap;
}
:deep(.nav-icon.on) .ttl {
  color: #3060d9 !important;
  font-weight: 500 !important;
}
/* 260716 인라인 SVG 탭(260918 통계 탭) — nav-img 필터 대신 stroke 로 회색/블루 렌더 */
.nav-icon .nav-svg { display: block; width: 2.4rem; height: 2.4rem; margin: 0 auto; stroke: #9aa0a6; opacity: 1; transition: stroke 0.15s; }
:deep(.nav-icon.on) .nav-svg { stroke: #3060d9; }
/* 260716 좌우 그룹 — 양쪽 flex:1 동일 폭 → 가운데 공유 FAB(auto) 정중앙, 탭 4개 균등 */
/* 260811 유저 — 탭 4개가 바닥에 붙어 보임: 그룹을 바 전체 높이로 펴고 세로 중앙정렬 */
.nav-side { display: flex; flex: 1 1 0; min-width: 0; align-self: stretch; align-items: center; }
.nav-side .nav-icon { flex: 1 1 0; min-width: 0; width: auto; }
.nav-icon.more-btn { flex: 0 0 auto; }

/* 공유 FAB — 밝은 초록 원 + 흰 인라인 SVG share 아이콘 */
.nav-icon.more-btn .round {
  /* 시안: #3856DC + 0.4 헤일로 링 */
  background: #3856dc !important;
  border: 0 !important;
  box-shadow: 0 0 0 0.4rem rgba(56, 86, 220, 0.4), 0 0.3rem 0.9rem rgba(56, 86, 220, 0.45) !important;
}
.nav-icon.more-btn .round .fab-ico {
  width: 2.7rem;
  height: 2.7rem;
  display: block;
}
/* 시안 제공 share 에셋 — 원래 색(검정) 그대로 */
.nav-icon.more-btn .round .fab-ico--img {
  object-fit: contain;
}

.hamburger-icon {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  width: 22px;
  height: 18px;
  margin: 0 auto;
}
.hamburger-icon span {
  display: block;
  width: 100%;
  height: 2px;
  background: currentColor;
  border-radius: 2px;
}

/* 공유하기 버튼 — 잘림 방지 + 골프존 비율로 축소 (260420) */
.nav {
  position: relative;
  z-index: 9999;
  overflow: visible;
}
:deep(.nav-icon.more-btn) {
  min-height: 4.6rem !important; /* 260811 — 바 높이 5rem에 맞춰 축소(원형 72unit 잔재) */
  padding: 0.2rem 0.4rem 0.4rem !important;
}
:deep(.nav-icon.more-btn .round) {
  width: 4.4rem !important;
  height: 4.4rem !important;
  position: relative;
  z-index: 1;
}
:deep(.nav-icon.more-btn .round .ico-round-icon) {
  width: 2.6rem !important;
  height: 2.6rem !important;
}

/* 261020 사용자 '간판온 색깔은 그대로' — 기관 회원도 간판ON 검은 바. 3칸 폭은 주차판 회원과 같다. */
.nav--org .nav-side:first-child,
.nav--parking .nav-side:first-child { flex: 1 1 0; }
.nav--org .nav-side:last-child,
.nav--parking .nav-side:last-child { flex: 2 1 0; }
</style>
